import { Lock } from 'lucide-react';

/** Small "🔒 Pro" / "🔒 Business" pill shown on locked features. */
export function PlanLockBadge({ plan = 'Pro', className = '' }) {
  return (
    <span className={`ml-1.5 inline-flex items-center gap-0.5 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 ${className}`}>
      <Lock className="h-2.5 w-2.5" /> {plan}
    </span>
  );
}
